import { createSlice } from "@reduxjs/toolkit";
import helperFunctions from "../../utils/helper";
const selectAllOptions = process.env.REACT_APP_ALL_SELECT_OPTION;

const initialState = {
  data: [],
  dataMap: {},
  selected: {},
  workerZone: [],
  selectedWorkerZone: {},
  zoneWiseWorkerDict: {},
  loading: false,
  error: null,
};

const fieldMembers = createSlice({
  name: "fieldMembers",
  initialState,
  reducers: {
    fetchFieldMembersStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchFieldMembersSuccess(state, action) {
      console.log("fetchDataSuccess Field Workers success");
      
      
      state.loading = false;

      const tempData = action.payload;
      const tempDataMap = {};

      for (let i = 0; i < tempData.length; i++) {

        tempDataMap[tempData[i].employee_id] = tempData[i];

      }

      const zoneValues = helperFunctions.getDistinctValues(
        action.payload,
        "zone"
      );
      zoneValues.unshift(selectAllOptions)
      const distinctZones = helperFunctions.sortZoneValues(zoneValues)
      const tempZoneWiseWorker = {}
      for (let i = 0; i < distinctZones.length; i++){
        let workersTempList = []
        for (let j = 0; j < tempData.length; j++){
          if(tempData[j].zone == distinctZones[i]){
            workersTempList.push(tempData[j])
          }
        }
        tempZoneWiseWorker[distinctZones[i]] = workersTempList
      }

      for (let key in tempZoneWiseWorker) {
        console.log(`Key: ${key}, Value: ${tempZoneWiseWorker[key]}`);
      }

      state.data = tempData;
      state.dataMap = tempDataMap;
      state.workerZone = distinctZones
      state.selectedWorkerZone = helperFunctions.selectAllValues(distinctZones);
      state.zoneWiseWorkerDict = tempZoneWiseWorker
      console.log("distinct zones ", distinctZones)
      console.log("field workers zones ", state.workerZone)
      console.log("zones selected ", state.selectedWorkerZone)

      console.log("fetchDataSuccess Field Workers success data");
    },
    addMembers(state, action) {
      state.loading = false;
      state.error = null;
      console.log("Field Member details ", action.payload)
      console.log("Field Member employee ID ", action.payload["employee_id"])

      const empData = action.payload;

      if (!empData) {
        console.error("formData is undefined in action.payload");
        return;
      }

      state.data.push(empData);
      state.dataMap[action.payload["employee_id"]] = action.payload
    },

    updatefieldMember(state, action) {

      const { employee_id, ...updateDetails } = action.payload.updateFormData;


      const updatedData = [];

      state.loading = false;
      state.error = null;


      if (state.dataMap[employee_id]) {
        for (const key in updateDetails) {
          if (updateDetails[key] !== undefined) {
            state.dataMap[employee_id][key] = updateDetails[key];
          }

        };
        for (const key in state.dataMap) {
          if (state.dataMap[key]) {
            updatedData.push(state.dataMap[key]);
          }
        }

        state.data = updatedData;
        console.log(`Employee successfully updated.`);
      } else {
        console.error(`No Employee Found with ID: ${employee_id}`);
      }

    },


    deleteFieldMembers(state, action) {
      state.loading = false;
      state.error = null;
      const updatedList = [];
      if (state.dataMap[action.payload]) {
        delete state.dataMap[action.payload];

        for (const key in state.dataMap) {
          if (state.dataMap[key]) {
            updatedList.push(state.dataMap[key]);
          }
        }

        state.data = updatedList;
      }
    },


    selectFieldMembers(state, action) {
      state.loading = false;
      state.selected = {
        ...state.selected,
        ...action.payload,
      };
    },


    selectWorkerZone(state, action){
      state.loading = false;
      state.selectedWorkerZone= {
        ...state.selectedWorkerZone,
        ...action.payload,
      };
    },

    fetchFieldMembersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetFieldMembers(state) {
      state.data = [];
      state.dataMap = {};
      state.selected = {};
      state.workerZone = [];
      state.selectedWorkerZone = {};
      state.loading = false;
      state.error = null;
    }
  },
});

export const {
  fetchFieldMembersStart,
  fetchFieldMembersSuccess,
  addMembers,
  selectFieldMembers,
  fetchFieldMembersFailure,
  resetFieldMembers,
  updatefieldMember,
  deleteFieldMembers,
  selectWorkerZone
} = fieldMembers.actions;
export default fieldMembers.reducer;
